import React from 'react'
import Verify from '../Components/Verify'

function VerifyPage() {

  return (
      <div className="bg-gradient-to-r from-blue-300 to-blue-400"><Verify /></div>
  )
}

export default VerifyPage